import LatLngLiteral = google.maps.LatLngLiteral;

import {Coordinate} from "@luminate/luminate-ts-sdk";

export const CoordinateToLatLngLiteralConverter = (source?: Coordinate): LatLngLiteral | undefined => {
    return source ? {lat: source?.latitude, lng: source?.longitude} as LatLngLiteral : undefined;
};